export interface DialCode {
  iso: string;
  dial: string;
}

/** Calling codes offered in the phone fields; the first entry of a shared code (+1, +7, +44) wins when a number is parsed. */
export const DIAL_CODES: DialCode[] = [
  ["IT", "+39"], ["DE", "+49"], ["AT", "+43"], ["CH", "+41"], ["FR", "+33"], ["ES", "+34"], ["GB", "+44"], ["US", "+1"],
  ["AD", "+376"], ["AE", "+971"], ["AL", "+355"], ["AR", "+54"], ["AU", "+61"], ["BA", "+387"], ["BD", "+880"], ["BE", "+32"],
  ["BG", "+359"], ["BR", "+55"], ["BY", "+375"], ["CA", "+1"], ["CL", "+56"], ["CN", "+86"], ["CO", "+57"], ["CY", "+357"],
  ["CZ", "+420"], ["DK", "+45"], ["DZ", "+213"], ["EE", "+372"], ["EG", "+20"], ["FI", "+358"], ["GR", "+30"], ["HR", "+385"],
  ["HU", "+36"], ["ID", "+62"], ["IE", "+353"], ["IL", "+972"], ["IN", "+91"], ["IR", "+98"], ["IS", "+354"], ["JP", "+81"],
  ["KE", "+254"], ["KR", "+82"], ["KW", "+965"], ["LI", "+423"], ["LK", "+94"], ["LT", "+370"], ["LU", "+352"], ["LV", "+371"],
  ["MA", "+212"], ["MC", "+377"], ["MD", "+373"], ["ME", "+382"], ["MK", "+389"], ["MT", "+356"], ["MX", "+52"], ["MY", "+60"],
  ["NG", "+234"], ["NL", "+31"], ["NO", "+47"], ["NZ", "+64"], ["PE", "+51"], ["PH", "+63"], ["PK", "+92"], ["PL", "+48"],
  ["PT", "+351"], ["QA", "+974"], ["RO", "+40"], ["RS", "+381"], ["RU", "+7"], ["SA", "+966"], ["SE", "+46"], ["SG", "+65"],
  ["SI", "+386"], ["SK", "+421"], ["SM", "+378"], ["TH", "+66"], ["TN", "+216"], ["TR", "+90"], ["UA", "+380"], ["VE", "+58"],
  ["VN", "+84"], ["XK", "+383"], ["ZA", "+27"],
].map(([iso, dial]) => ({ iso, dial }));

export const DEFAULT_DIAL = "+39";
